import * as React from 'react';
//import { FormattedMessage } from "react-intl";

import { library } from '@fortawesome/fontawesome-svg-core';
import { faShareAlt } from '@fortawesome/free-solid-svg-icons';
//import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import './share.scss';
library.add(faShareAlt);
// todo fix link
class Share extends React.Component {
    render() {
        return ( 
            /*<div className="share-bar">
                <FormattedMessage id="General.shareLink">
                {link => 
                    <a href={link} target="_blank" rel="noopener noreferrer" className="btn" role="button">
                        <FormattedMessage id="General.share" defaultMessage="Share" /> <FontAwesomeIcon icon="share-alt" /> 
                    </a>
                }
                </FormattedMessage>
            </div>*/
            ""
        )
    }
}

export default Share;
